import BaseCom from "../../components/BaseCom";
import AppActions from "../../components/Solusek/AppActions";
import DataView from "../../components/Solusek/DataView";
import { withParamsAndNavigate } from "../../components/WithParamsAndNavigate";
import Icon from "../../components/Icon";
import L from "../../components/Lang";
import { Accordion, Modal } from "react-bootstrap";
import FormInputV2 from "../../components/FormInputV2";
import { qreq } from "../../shared/qrequest";
import { Pop } from "../../components/PopModal";
import Switch from "../../components/Switch";
import CodeEditor from "../../components/Solusek/CodeEditor";
import APIProperties from "./components/APIProperties";

class WebhookManager extends BaseCom {

    constructor(props) {
        super(props);
        this.state = {
            item: {
                scope: {}
            },
            scopeList: [],
            webhookScopes: []
        };

        // TODO: remap this, do not confuse with the scope saved
        this.webhookScopesSrc = [
            {
                scope: "RESULTS",
                ident: "LabResults"
            }
        ];
    }

    async componentDidMount() {
        await this.fillListAsync('/api/api-client/list', 'clients');
        await this.fillListAsync('/api/webhook/scope/list', 'scopeList');
        await this.loadAsync();
    }

    loadAsync = async () => {
        let webhookScopes = [...this.state.webhookScopes];

        for (var n = 0; n < this.webhookScopesSrc.length; n++) {
            var i = { ...this.webhookScopesSrc[n] };
            try {
                let j = await qreq.getAsync('/api/spec/webhook/model/' + i.ident);
                if (j.item) {
                    i.spec = j.item;
                    webhookScopes.push(i);
                }
            }
            catch (e) {
                console.error(e);
            }
        }
        this.setState({ webhookScopes });
    }

    submit = async (e) => {
        e?.preventDefault();
        let item = { ...this.state.item };

        let set = false;
        for (var k in item.scope) {
            if (item.scope[k])
                set = true;
        }

        if (!set) {
            this.alert('Please select a scope.');
            return;
        }

        this.setState({ submitting: true });
        item.apiClientID = parseInt(item.apiClientID);
        try {
            let j = await qreq.postAsync('/api/webhook/save', item);
            if (j.item) {
                this.setState({ newItem: j.item, showSave: false });
                this.rehash();
            }
            else
                this.alert(j.errorMessage);
        }
        catch (e) {
            this.unkownErrorCallback(e);
        }
        this.setState({ submitting: false });
    }

    remove = (item) => {
        Pop.showConfirm(<L>Remove Webhook</L>, <L>Are you sure you want to remove Webhook <strong>{item.name}</strong>?</L>, async () => {
            try {
                let j = await qreq.postAsync('/api/webhook/remove', item);
                if (j.errorCode === 0) {
                    this.success(<L>Deleted Webhook.</L>);
                    this.rehash();
                }
                else
                    this.alert(j.errorMessage);
            }
            catch (e) {
                this.unkownErrorCallback(e);
            }
        });
    }

    change = () => {
        this.setState({ item: { ...this.state.item } });
    }

    doc = () => {
        return (<>
            <h2><L>Documentation</L></h2>
            <Accordion>
                {this.state.webhookScopes.map((i, idx) => <Accordion.Item key={idx} eventKey={idx}>
                    <Accordion.Header>{i.spec?.name} Webhook</Accordion.Header>
                    <Accordion.Body>
                        <p className="lead"><L>You will receive a REST/JSON POST request with...</L></p>
                        <h5><L>Body</L></h5>
                        {i.spec && <div className="mb-3">
                            <CodeEditor value={i.spec.jsonBody} height="50vh" onChange={(v) => {
                                i.spec.jsonBody = v;
                                let webhookScopes = [...this.state.webhookScopes];
                                this.setState({ webhookScopes });
                            }} />
                        </div>}
                        <h5><L>Properties</L></h5>
                        {i.spec && <APIProperties properties={i.spec.properties} />}
                    </Accordion.Body>
                </Accordion.Item>)}
            </Accordion>
            </>
        );
    }

    new = () => {
        this.setState({
            showSave: true, item: {
                scope: {},
                retryMaxCount: '0',
                retryDelaySeconds: 5,
                retryMultiplier: 1
            }, newItem: null
        });
    }

    render() {
        return (
            <div className="container-fluid">

                <Modal show={this.state.showSave} onHide={() => this.setState({ showSave: false })} size="lg"
                    backdrop="static" keyboard={false}>
                    <Modal.Header>
                        <Modal.Title>Webhook</Modal.Title>
                    </Modal.Header>
                    <form onSubmit={this.submit}>
                        <Modal.Body>
                            <div>
                                <FormInputV2 model={this.state.item} name="apiClientID" label="Instance"
                                    required type="select" options={this.state.clients} onChange={this.change} />
                                <FormInputV2 model={this.state.item} name="scope" label="Scope"
                                    required type="select" options={this.state.scopeList} onChange={this.change} />
                                <FormInputV2 model={this.state.item} name="url" label="URL" onChange={this.change} required />
                                <Switch model={this.state.item} name="hasAuthentication" label="Has Bearer Authentication" onChange={this.change} />
                                {this.state.item.hasAuthentication && <FormInputV2 model={this.state.item} name="authenticationToken" label="Authentication Bearer Token" onChange={this.change} required />}
                                <FormInputV2 model={this.state.item} name="retryMaxCount" label="Retry Max Count" type="number" onChange={this.change} note="Leave as 0 for infinite retries." />
                                <FormInputV2 model={this.state.item} name="retryDelaySeconds" label="Retry Delay in Seconds" type="number" onChange={this.change} required />
                                <FormInputV2 model={this.state.item} name="retryMultiplier" label="Retry Multiplier" type="number" onChange={this.change} required />
                                
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <div>
                                <button type="submit" className="btn btn-success">
                                    <L>Save</L>
                                </button>
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ showSave: false })}>
                                    <L>Cancel</L>
                                </button>
                            </div>
                        </Modal.Footer>
                    </form>
                </Modal>


                <h1><L>Webhooks</L></h1>
                <DataView api={'/api/webhook/list'} hash={this.state.hash} actions={[
                    {
                        label: <Icon icon="faTrash" />,
                        danger: true,
                        onClick: this.remove
                    }
                ]} />

                

                {this.doc()}

                <AppActions>
                    <button type="button" className="btn btn-lg btn-primary" onClick={this.new}>
                        <Icon icon="faPlus" /> <L>New Webhook</L>
                    </button>
                </AppActions>
            </div>
        )
    }
}

export default withParamsAndNavigate(WebhookManager);